import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/components/Mapa')
  },
  {
    path: '/pesquisa/agente',
    component: () => import('@/components/Agente')
  },
  {
    path: '/pesquisa/equipamento',
    component: () => import('@/components/Equipamento')
  },
  {
    path: '/pesquisa/meio_comunicacao',
    component: () => import('@/components/MeioComunicacao')
  },
  {
    path: '/atividade',
    component: () => import('@/components/Atividade')
  },

  {
    path: '/patrimonio/:id',
    component: () => import('@/views/patrimonio/Patrimonio')
  },
  {
    path: '/patrimonios',
    component: () => import('@/views/patrimonio/Patrimonios')
  },
  {
    path: '/agentes',
    component: () => import('@/views/agente/Agente')
  },
  {
    path: '/projeto_apresentado',
    component: () => import('@/components/ProjetoApresentado')
  },
  {
    path: '/projeto_selecionado',
    component: () => import('@/components/ProjetoSelecionado')
  },
  {
    path: '/projeto_contemplado',
    component: () => import('@/components/ProjetoContemplado')
  },
  {
    path: '/local_realizacao',
    component: () => import('@/components/LocalRealizacao')
  },
  {
    path: '/orcamento_projeto_solicitado',
    component: () => import('@/components/OrcamentoProjetoSolicitado')
  },
  {
    path: '/orcamento_projeto_contemplado',
    component: () => import('@/components/OrcamentoProjetoContemplado')
  },

  {
    path: '/orgao',
    component: () => import('@/components/Orgao')
  },
  {
    path: '/gestor/:codigo',
    component: () => import('@/components/Gestor')
  },
  {
    path: '/perfilgestor',
    component: () => import('@/components/PerfilGestor')
  },
  {
    path: '/conselhomunicipal',
    component: () => import('@/components/ConselhoMunicipal')
  },
  {
    path: '/instrumentogestao',
    component: () => import('@/components/InstrumentoGestao')
  },
  {
    path: '/legislacao',
    component: () => import('@/components/Legislacao')
  },
  {
    path: '/recursofinanceiro',
    component: () => import('@/components/RecursoFinanceiro')
  },

  {
    path: '/marcadores/atividades',
    component: () => import('@/views/markers/Atividade')
  },
  {
    path: '/lista/agentes_culturais',
    component: () => import('@/views/list/AgentesCulturais')
  },
  {
    path: '/lista/instrumento_gestao',
    component: () => import('@/views/list/InstrumentoGestao')
  },
  {
    path: '/grafico/atividades',
    component: () => import('@/views/chart/Atividade')
  },

  {
    path: '/equipamentos',
    component: () => import('@/views/markers/Equipamento')
  },
  {
    path: '/equipamento/:id',
    component: () => import('@/views/equipamento/Equipamento')
  },
  {
    path: '/equipamento_grafico',
    component: () => import('@/views/equipamento/Grafico')
  },
  {
    path: '/meio_comunicacao',
    component: () => import('@/views/markers/MeioComunicacao')
  },
  /*{
    path: '/meio_comunicacao/:id',
    component: () => import('@/views/equipamento/MeioComunicacao')
  },*/
  {
    path: '/sisprofice',
    component: () => import('@/views/sisprofice/Sisprofice')
  },

  {
    path: '/accessdenied',
    component: () => import('@/views/layout/errors/Deny')
  },
  {
    path: '/error',
    component: () => import('@/views/layout/errors/Error')
  },
  {
    path: '/*',
    component: () => import('@/views/layout/errors/NotFound')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('setMessages', null)

  // protected access
  if (to.meta.requiresAuth) {
    (async () => {
      if (await store.dispatch('authFilter')) {
        if (store.getters.isAuthenticated == true) {
          // root redirect
          if (to.path === '/') {
            store.commit('setLayout', 'admin')

            next('/') // home
          }
          // permission groups
          if (to.meta.groups && to.meta.groups.length > 0) {
            const userData = JSON.parse(store.getters.getUser)
            if (userData.token.groups) {
              let permission = false; let groupName = ''
              for (let i = 0; i < userData.token.groups.length; i++) {
                groupName = userData.token.groups[i].nome
                if (to.meta.groups.indexOf(groupName) != -1) {
                  permission = true
                  break
                }
              }
              if (permission) { // permission granted
                store.commit('setLayout', 'admin')
                next()
              } else { // permission denied
                store.commit('limparUserState')
                store.commit('setLayout', 'blank')
                next('/accessdenied')
              }
            }
          }
        } else {
          store.commit('limparUserState')
          store.commit('setLayout', 'blank')
          next('/accessdenied')
        }
      }
    })()
  }

  // Monitoring, Notfound, AccessDenied
  else if (to.name === 'Monitoramento' ||
    to.name === 'NotFound' ||
    to.name === 'AccessDenied') {
    store.commit('setLayout', 'blank')
    next()
    return
  }

  // public access
  else {
    next()
  }
})

export default router
